<template>
    <Breadcrumbs main="Apps" title="Kanban Board" />
    <div class="container-fluid jkanban-container">
        <div class="row">
            <defaultDemo />
            <customDome />
            <apiDome />
        </div>
    </div>
</template>
<script lang="ts" setup>
import { ref, defineAsyncComponent } from 'vue'

const defaultDemo = defineAsyncComponent(() => import("@/components/theme/kanbanboard/defaultDemo.vue"))
const customDome = defineAsyncComponent(() => import("@/components/theme/kanbanboard/customDome.vue"))
const apiDome = defineAsyncComponent(() => import("@/components/theme/kanbanboard/apiDome.vue"))
</script>